import { CustomTheme } from '@flatfile/turntable'

export const BaselineTurntableTheme: CustomTheme = {
  //rowHeight: 30,
  indexColumn: {
    backgroundColor: 'var(--colors-base-white)',
    borderColor: 'var(--colors-border-90)',
    color: 'var(--colors-muted-foreground-100)',
    fontFamily: 'var(--table-font-family)',
    selected: {
      color: 'var(--colors-primary-100)',
      backgroundColor: 'var(--colors-accent-90)',
    },
  },
  inputs: {
    radio: {
      color: 'var(--colors-primary-100)',
    },
    checkbox: {
      color: 'var(--colors-primary-100)',
      borderRadius: 'var(--radius-xs)',
      borderColor: 'var(--colors-border-90)',
    },
    search: {
      borderColor: 'var(--colors-border-90)',
    },
  },
  table: {
    backgroundColor: 'var(--colors-background-80)',
    borderColor: 'var(--colors-border-90)',
  },
  cell: {
    borderColor: 'var(--colors-border-80)',
    mutatedUnderlineColor: 'var(--colors-primary-100)',
    borderRadius: 'var(--radius-xs)',
    selected: {
      backgroundColor: 'var(--colors-primary-10)',
    },
    active: {
      borderColor: 'var(--colors-primary-100)',
      spinnerColor: 'var(--colors-primary-100)',
    },
    error: {
      backgroundColor: 'var(--colors-destructive-30)',
      color: 'var(--colors-destructive)',
      borderColor: 'var(--colors-destructive)',
    },
    warning: {
      backgroundColor: 'var(--colors-warning-20)',
      color: 'var(--colors-warning)',
      borderColor: 'var(--colors-warning)',
    },
  },
  lookupEditor: {
    option: {
      borderRadius: {
        active: 'var(--radius-xs)',
      },
    },
  },
  boolean: {
    toggleError: 'var(--colors-destructive)',
    toggleWarning: 'var(--colors-warning)',
    toggleChecked: 'var(--colors-primary-100)',
  },
  loading: {
    color: 'var(--colors-primary-100)',
  },
  column: {
    header: {
      fontFamily: 'var(--table-font-family)',
      backgroundColor: 'var(--colors-base-white)',
      borderColor: 'var(--colors-border-90)',
      color: 'var(--colors-muted-foreground-100)',
      dragHandle: {
        idle: 'var(--colors-primary-100)',
        dragging: 'var(--colors-primary-80)',
      },
    },
    selected: {
      borderColor: 'var(--colors-primary-100)',
      backgroundColor: 'var(--colors-primary-10)',
    },
  },
  filters: {
    color: 'var(--colors-muted-foreground-100)',
    backgroundColor: '#fff',
    active: {
      backgroundColor: 'var(--colors-primary-100)',
      secondaryBackgroundColor: 'var(--colors-primary-80)',
    },
    error: {
      color: 'var(--colors-destructive)',
      secondaryColor: 'var(--colors-destructive-90)',
      activeBackgroundColor: 'var(--colors-destructive)',
      secondaryBackgroundColor: 'var(--colors-destructive-100)',
    },
    innerBorderRadius: 'var(--radius-full)',
    outerBorderRadius: 'var(--radius-full)',
  },
  buttons: {
    pill: {
      borderRadius: 'var(--radius-full)',
      dropdown: {
        borderColor: 'var(--colors-border-90)',
      },
    },
  },
  tooltip: {
    borderRadius: 'var(--radius-xs)',
  },
}
